import { render, staticRenderFns } from "./roleFields.vue?vue&type=template&id=17876d6e&scoped=true"
import script from "./roleFields.vue?vue&type=script&lang=js"
export * from "./roleFields.vue?vue&type=script&lang=js"
import style0 from "./roleFields.vue?vue&type=style&index=0&id=17876d6e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17876d6e",
  null
  
)

export default component.exports